<div style="max-width: 300px;">
    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div mat-dialog-title class="dialog-title">Seleccionar Productos Combo:&nbsp;{{producto.nombre_producto}}</div>
        <app-button type="icon" color="gray" [icon_fig]="Icons.CLOSE" (click)="onClose()"
            [attr_disabled]="isLoading"></app-button>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-content style="min-width: 250px; margin-top: 20px;">
        <section>
            <div *ngIf="producto.cantidad_productos_combo_seleccionables" style="margin-bottom: 5px;">
                <span style="font-weight: bold;" >Cantidad seleccionable:&nbsp;{{producto.cantidad_productos_combo_seleccionables}}</span>
            </div>
            <form #f="ngForm" (ngSubmit)="onSubmit(f)" fxLayout="column" fxLayoutGap="15px">
                <ng-container *ngFor="let cant of nroProductos!; let i=index">
                   <mat-form-field style="width: 100%;">
                        <mat-label>Producto # {{i+1}}:</mat-label>
                        <mat-select
                        required
                        name="producto_{{i}}"
                        [id]="'listaProd_'+i"
                        required                        
                         [(ngModel)]="subProductoSel[i]"
                        (selectionChange)="seleccionarSubProductoCombo(subProductoSel[i], i)"                        
                        #tipoCaracteristica="ngModel">
                            <mat-option *ngFor=" let subProd of producto.subproductos"
                            [value]="subProd"
                             >{{subProd.producto.nombre_producto}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="tipoCaracteristica.hasError('required')">{{Msjs_Validations.MSJ_VAL_CAMPO_VACIO}}</mat-error>
                    </mat-form-field>
                </ng-container>
              <mat-divider style="margin-bottom: 20px; margin-top: 20px;"></mat-divider>                
                <mat-card-actions fxLayout="row" fxLayoutAlign="space-around center">
                    <app-button [width]="100" text="Seleccionar" fxFlex="70%" fxFlex.xs="60%" [attr_disabled]="!f.valid"
                      [attr_type]="'submit'"></app-button>
                    <app-button fxHide.xs type="outline" [width]="100" text="Limpiar" color="gray"
                      (click)="Limpiar(f)"></app-button>
                    <app-button fxShow.xs fxHide type="outline" color="gray-b0" [icon_fig]="Icons.CLEANING"
                      (click)="Limpiar(f)"></app-button>
                  </mat-card-actions>
            </form>
        </section>
    </mat-dialog-content>
</div>